/* eslint-disable @typescript-eslint/consistent-type-definitions -- Zero mutator/query arg types must be `type` aliases to satisfy the ReadonlyJSONValue constraint; interfaces lack an implicit index signature. */
import { defineMutator } from "@rocicorp/zero"

import type { ZeroJwtPayload } from "@productlane/lib/src/browser"

import type { MutatorTx } from "../schema"

export type ArchiveAiChatSessionArgs = {
	id: string
	// false restores the chat to the sidebar.
	archived: boolean
}

export const aiChatSessionMutators = {
	// Only the chat's owner archives it; a teammate's chats are never theirs to hide.
	archive: defineMutator(
		async ({
			tx,
			args,
			ctx: authData,
		}: {
			tx: MutatorTx
			args: ArchiveAiChatSessionArgs
			ctx: ZeroJwtPayload
		}) => {
			const [session] = await tx.query.aiChatSessions
				.where("id", "=", args.id)
				.run()
			if (
				!session ||
				session.workspaceId !== authData.workspaceId ||
				session.userId !== authData.userId
			) {
				return
			}
			await tx.mutate.aiChatSessions.update({
				id: args.id,
				archivedAt: args.archived ? Date.now() : null,
			})
		},
	),
}
